<template>
  <div class="donor-item">
    <div class="donor-item__name">{{ donor.name }}</div>
    <div class="donor-item__title">{{ donor.title }}</div>
  </div>
</template>

<script>
export default {
  name: "DonorItem",
  props: {
    donor: Object,
  },
};
</script>

<style scoped lang="scss">
.donor-item {
  &__name {
    font-weight: bold;
    font-size: 24px;
    line-height: 24px;
  }
  &__title {
    margin-top: 12px;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #101820;
  }
}
</style>